import styled from '@emotion/styled'

export const Wrapper = styled.div`
  margin-bottom: 1em;
  flex: 1;
  position: relative;
`

export const Label = styled.label`
  display: block;
  margin-bottom: .2em;
`

export const Colors = styled.div`
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  gap: .5em;
  margin-top: .4em;

  @media (max-width: ${props => props.theme.mobileBreakpoint}) {
    grid-template-columns: repeat(6, 1fr);
  }
`

export const Color = styled.button`
  font: inherit;
  color: white;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${props => props.theme.primary[props['data-color']]};
  border-radius: .3em;
  aspect-ratio: 1 / 1;

  &[aria-selected=true] {
    box-shadow: 0 0 0 1px ${props => props.theme.background}, 0 0 0 3px ${props => props.theme.text};
  }
`

export const Error = styled.span`
  display: block;
  font-size: .8em;
  color: ${props => props.theme.primary.red};
  margin-top: .2em;
`